<template>
  <v-card max-width="100%" outlined class="card my-0" :color="color" dark :transition="transition">
    <v-list-item three-line>
      <v-icon :size="size" class="cardIcon">{{ icon }}</v-icon>
      <v-list-item-content>
        <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
        <v-list-item-title class="headline mb-1" v-show="animated">
          <animated-number :value="title" :formatValue="format" :duration="500" />
        </v-list-item-title>
        <v-list-item-title class="headline mb-1" v-show="!animated">
          {{ title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
export default {
  name: 'DashboardCard',
  components: {
    AnimatedNumber,
  },
  props: ['title', 'subtitle', 'icon', 'color', 'size', 'transition', 'animated'],
  computed: {
    cssVars() {
      return { '--border-color': this.color, '--icon-color': this.color }
    },
  },
  data: () => ({}),
  methods: {
    format(number) {
      if (number < 100000) {
        return `R$ ${(number / 100).toFixed(2).replace('.', ',')}`
      }
      if (number >= 100000 && number < 99999999) {
        return `R$ ${(number / 100000).toFixed(2).replace('.', ',')} K`
      }
      if (number >= 99999999) {
        return `R$ ${(number / 100000000).toFixed(2).replace('.', ',')} M`
      }
    },
  },
}
</script>

<style scoped>
.card {
  border-top: 4px solid var(--border-color) !important;
  margin: auto;
}
.cardIcon {
  color: var(--icon-color) !important;
  margin-right: 10px;
}
</style>
